import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Map, { Source, Layer } from "react-map-gl";
import bbox from "@turf/bbox";
import {
  setSelectedCounty,
  setSelectedFips,
  setSelectedState,
} from "../../Redux/filterSlice";
import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { fetchGeoCountiesByState } from "../../Redux/geo/geoThunk";

function FilterMap(
  {
    // setClickedState,
    // setClickedCounty,
    // setClickedFips,
    // selectedFips,
  }
) {
  const mapRef = useRef();
  const [cursor, setCursor] = useState("auto");
  const { selectedFips, selectedState } = useSelector((state) => state.filter);
  const stateFilter = [
    "match",
    ["get", "STATE"],
    ["AR", "IA", "IL", "IN", "LA", "MO", "MS", "OH"],
    true,
    false,
  ];
  const countyFilter = ["==", "FIPS", selectedFips];
  const dispatch = useDispatch();

  const onMapClick = useCallback(
    (event) => {
      if (event.features.length > 0) {
        const county = event.features[0];
        const newState = county.properties.STATE;
        const newCounty = county.properties.COUNTYNAME;
        const newFips = county.properties.FIPS;

        if (selectedState !== newState) {
          dispatch(fetchGeoCountiesByState(newState));
        }

        dispatch(setSelectedState(newState));
        dispatch(setSelectedCounty(newCounty));
        dispatch(setSelectedFips(String(newFips).padStart(5, "0")));
      }
    },
    [selectedState]
  );

  const onMouseEnter = () => {
    setCursor("pointer");
  };

  const onMouseLeave = () => {
    setCursor("auto");
  };

  useEffect(() => {
    if (!mapRef.current || !selectedFips) return;

    if (!mapRef.current.isStyleLoaded()) return;

    const features = mapRef.current.querySourceFeatures("map-source", {
      sourceLayer: "c_08mr23-1pp4eg",
      filter: ["==", "FIPS", selectedFips],
    });

    if (features.length) {
      const [minLng, minLat, maxLng, maxLat] = bbox(features[0]);
      mapRef.current.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat],
        ],
        { padding: 40, duration: 1000 }
      );
    } else {
      mapRef.current.fitBounds(
        [
          [-95.6, 30.3],
          [-89.1, 41.3],
        ],
        { padding: 40, duration: 1000 }
      );
    }
  }, [selectedFips]);

  return (
    <Map
      ref={mapRef}
      mapboxAccessToken="pk.eyJ1IjoiY2h1Y2swNTIwIiwiYSI6ImNrMDk2NDFhNTA0bW0zbHVuZTk3dHQ1cGUifQ.dkjP73KdE6JMTiLcUoHvUA"
      initialViewState={{
        longitude: -91,
        latitude: 36,
        zoom: 4,
      }}
      //Anthony - changed style and onRender to resize the map without distortion
      style={{ width: "60vw", height: "50vh" }}
      mapStyle="mapbox://styles/mapbox/light-v9"
      cursor={cursor}
      interactiveLayerIds={["county-boundary"]}
      onRender={(event) => event.target.resize()}
      onClick={onMapClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Source
        id="map-source"
        type="vector"
        url="mapbox://chuck0520.5pq9omti"
        maxzoom={22}
        minzoom={0}
      >
        <Layer
          id="county-boundary"
          source-layer="c_08mr23-1pp4eg"
          type="fill"
          paint={{
            "fill-outline-color": "#800000",
            "fill-color": "#800000",
            "fill-opacity": 0.2,
          }}
          minzoom={0}
          maxzoom={22}
          filter={stateFilter}
        />
        <Layer
          id="county-highlight"
          source-layer="c_08mr23-1pp4eg"
          type="fill"
          paint={{
            "fill-outline-color": "#800000",
            "fill-color": "#800000",
            "fill-opacity": 0.4,
          }}
          minzoom={0}
          maxzoom={22}
          filter={countyFilter}
        />
        <Layer
          id="county-labels"
          type="symbol"
          source="map-source"
          source-layer="c_08mr23-1pp4eg"
          layout={{
            "text-field": ["get", "COUNTYNAME"],
            "text-size": {
              stops: [
                [0, 0],
                [4, 0],
                [6, 10],
                [8, 15],
              ],
            },
          }}
          paint={{ "text-color": "#800000" }}
          filter={stateFilter}
        />
      </Source>
    </Map>
  );
}
export default FilterMap;
